// src/composables/api/useUserApi.ts
import { useAuthHttp } from './useAuthHttp';
import { AxiosRequestConfig } from 'axios';

// import {Tournament} from '@/interfaces/TournamentInterface';


export function useEventsApi() {
    const { get, post, patch, del } = useAuthHttp();

    const storeEvent = async (formData: object, config: AxiosRequestConfig = {}): Promise => {
        return await post('/events', formData, config);
    };

    const updateEvent = async (eventId: string | number, formData: object, config: AxiosRequestConfig = {}): Promise => {
        // If FormData, use POST with _method: PATCH (like activation groups)
        // Otherwise use PATCH directly
        if (formData instanceof FormData) {
            formData.append('_method', 'PATCH');
            return await post(`/events/${eventId}`, formData, config);
        } else {
            return await patch(`/events/${eventId}`, formData, config);
        }
    };

    const fetchEvents = async (config: AxiosRequestConfig = {}): Promise => {
        return await get('/events', config);
    };
    const fetchEvent = async (eventSlug: string, config: AxiosRequestConfig = {}): Promise => {
        return await get(`/events/${eventSlug}`, config);
    };
    const fetchOpenTeamEvents = async (config: AxiosRequestConfig = {}): Promise => {
        return await get('/events/open-for-registration', config);
    };
    const fetchActiveEvents = async (config: AxiosRequestConfig = {}): Promise => {
        return await get('/events/active', config);
    };
    const fetchActivePartnerEvents = async (config: AxiosRequestConfig = {}): Promise => {
        return await get('/events/active/partner', config);
    };
    const fetchEventsForSelection = async (config: AxiosRequestConfig = {}): Promise => {
        return await get('/events/selection', config);
    };

    return {
        storeEvent,
        updateEvent,
        fetchEvents,
        fetchEvent,
        fetchOpenTeamEvents,
        fetchActiveEvents,
        fetchActivePartnerEvents,
        fetchEventsForSelection
    };
}
